import type {
  DailyAccrualEntryOut,
  RevenueTrendEntryOut,
} from '@/api/generated/schemas';

// Oba endpointy trendów zwracają szeregi rzadkie — okresy bez emisji nie mają
// wiersza, więc oś czasu dopełniamy zerami po stronie klienta.

export type MonthlyPoint = {
  month: string; // YYYY-MM
  amount: number;
  payableAmount: number;
  basisSeconds: number;
  publisherCount: number;
  productCount: number;
  rate: number | null;
  current: boolean;
};

export const fillMonthlySeries = (
  entries: RevenueTrendEntryOut[],
  months: number
): MonthlyPoint[] => {
  const byMonth = new Map(entries.map((e) => [e.bucket.slice(0, 7), e]));
  const now = new Date();
  const points: MonthlyPoint[] = [];
  for (let i = months - 1; i >= 0; i--) {
    const month = new Date(
      Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - i, 1)
    )
      .toISOString()
      .slice(0, 7);
    const entry = byMonth.get(month);
    points.push({
      month,
      amount: entry ? Number(entry.amount) : 0,
      payableAmount: entry ? Number(entry.payable_amount) : 0,
      basisSeconds: entry?.basis_seconds ?? 0,
      publisherCount: entry?.publisher_count ?? 0,
      productCount: entry?.product_count ?? 0,
      rate:
        entry?.effective_hourly_rate != null
          ? Number(entry.effective_hourly_rate)
          : null,
      current: i === 0,
    });
  }
  return points;
};

export type DailyPoint = {
  day: string; // YYYY-MM-DD
  amount: number;
  today: boolean;
};

export const fillDailySeries = (
  entries: DailyAccrualEntryOut[],
  days: number
): DailyPoint[] => {
  const byDay = new Map(entries.map((e) => [e.bucket.slice(0, 10), e]));
  const todayMs = Date.now();
  const points: DailyPoint[] = [];
  for (let i = days - 1; i >= 0; i--) {
    const day = new Date(todayMs - i * 86_400_000).toISOString().slice(0, 10);
    const entry = byDay.get(day);
    points.push({
      day,
      amount: entry ? Number(entry.amount) : 0,
      today: i === 0,
    });
  }
  return points;
};
